import { Component, Inject, Input, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DxDataGridComponent } from 'devextreme-angular/ui/data-grid';
import Guid from 'devextreme/core/guid';
import { DataSourceOptions } from 'devextreme/data/data_source';
import moment from 'moment';
import { hAll } from 'src/app/shared/classes/utils/utils';
import { ABaseComponent } from 'src/app/shared/modules/ui/components/abstract/a-base.component';
import { DxCellPreparedEvent, DxToolbarPreparingEvent } from '../../../../core/dx.types';
import { ExtLoopBackAuth } from '../../../../shared/modules/ext-sdk/services/ext-sdk-auth.service';
import { DataSourceService } from '../../../../shared/modules/my-common/services/datasource.service';
import { UiService } from '../../../../shared/modules/ui/services/ui.service';
import { LoopBackAuth } from '../../../../shared/sdk';
import {
  AutoDispatchLog,
  Config,
  Consumer,
  ConsumerAddressView,
  TripManifest,
  TripManifestRec,
} from '../../../../shared/sdk/models';
import {
  AutoDispatchLogApi,
  ConfigApi,
  ConsumerAddressViewApi,
  ConsumerApi,
  LoggerService,
} from '../../../../shared/sdk/services/custom';
import { HelperService } from '../../../trip-manifest/services/helper.service';

@Component({
  selector: 'app-auto-dispatch-details-tab-accepted',
  templateUrl: './auto-dispatch-details-tab-accepted.component.html',
  styleUrls: ['./auto-dispatch-details-tab-accepted.component.scss'],
  providers: [HelperService],
})
export class AutoDispatchDetailsTabAcceptedComponent extends ABaseComponent {
  @ViewChild('grid', { static: false }) grid: DxDataGridComponent;
  _message: AutoDispatchLog;

  @Input()
  set message(m: AutoDispatchLog) {
    this._message = m;
    this.changeHandle();
  }
  get message() {
    return this._message;
  }

  dso: DataSourceOptions;
  grid_selectedRowKeys: number[] = [];
  selected: any[];
  destinationsMap: any;

  isToastVisible = false;
  toastMessage = '';
  toastType = 'info'; // can be 'info', 'warning', 'error', or 'success'

  constructor(
    protected logger: LoggerService,
    protected ui: UiService,
    protected dss: DataSourceService,
    protected dialog: MatDialog,
    public helper: HelperService,
    @Inject(LoopBackAuth) private auth: ExtLoopBackAuth,
  ) {
    super(logger);
  }

  async changeHandle() {
    if (this.message) {
      this.message.accepted.forEach(s => {
        s.dt = moment(s.Date, 'MM/DD/YY').format('YYYY-MM-DD');
        s.meta.internalId = s.meta.internalId || s.Vehicle;
        s.meta.driverName = s.meta.driverName || s.Driver;
        s.meta.tripSeq = s.meta.tripSeq !== undefined ? s.meta.tripSeq : s['Proposed Trip Sequesce'];
      });
      const destinations = await this.dss.getApi<ConfigApi>(Config).getAllDestinations().toPromise();
      this.destinationsMap = destinations.reduce(
        (p, d) => (d.address ? { ...p, [d.address.split(',')[0]]: d } : p),
        {},
      );
      await this.loadConsumers(this.message.accepted);
      this.dso = this.message.accepted;
    }
  }

  grid_onSelectionChanged = (event: any) => {
    this.selected = event.selectedRowsData;
  };

  grid_onToolbarPreparing(e: DxToolbarPreparingEvent): void {
    // console.log(e);

    e.toolbarOptions.items.unshift({
      name: 'markAsGranted',
      widget: 'dxButton',
      locateInMenu: 'auto',
      location: 'before',
      sortIndex: 30,
      options: {
        icon: 'check',
        text: 'Mark As Granted (Already added to Manufest)',
        hint: 'Mark As Granted (Already added to Manufest)',
        onClick: () => this.markAsGranted(),
      },
    });

    e.toolbarOptions.items.unshift({
      name: 'addToManifest',
      widget: 'dxButton',
      locateInMenu: 'auto',
      location: 'before',
      sortIndex: 30,
      // showText: 'inMenu',
      options: {
        icon: 'plus',
        text: 'Add Selected Trips To Manifest',
        hint: 'Add Selected Trips To Manifest',
        // disabled: !this.model,
        onClick: () => this.addToManifest(),
      },
    });
  }

  grid_onContextMenuPreparing(e) {
    if (e.row && e.row.rowType === 'data' && !e.row.isEditing) {
      this.grid_selectedRowKeys = [e.row.data];
      e.items = [
        {
          text: `Add To Manifest:  ${e.row.data['APPOINT TIME/RR TIME']} - ${e.row.data.Customer}`,
          onItemClick: () => this.addToManifest(),
        },
      ];
    }
  }

  grid_onCellPrepared(e: DxCellPreparedEvent) {
    if (e.rowType === 'data' && e.data.meta.allowed) e.cellElement.classList.add('cell-green');
  }

  status_calculateValue = (rowData): string => {
    return rowData.meta && rowData.meta.allowed ? 'On Manifest' : 'Requested';
  };

  settings_calculateValue = (rowData): string => {
    const { ks, puPlus, doPlus }: any = rowData.meta || {};
    return [ks && 'KS', puPlus && 'PU+', doPlus && 'DO+'].filter(Boolean).join(', ');
  };

  async loadManfiests(manifestsMap) {
    const manifests = await Promise.all(
      Object.keys(manifestsMap).map(date => this.helper.api.getCurrentManifest(date).toPromise()),
    );
    manifests.filter(m => m.date).forEach(m => (manifestsMap[m.date] = { ...m, data: [] }));
  }

  getCastomerNameAndAddress(s: any) {
    const [ln, fn] = s.Customer.split(', ');
    const [pick, drop] = ['Pick Location', 'Drop Location'];
    const [rAddr, adcAddr] = s.meta.isReturn ? [s[drop], s[pick]] : [s[pick], s[drop]];
    const [street, city, state, zip] = rAddr.split(/, ?/);
    const resAddr = { street, city, state, zip };
    return [fn, ln, adcAddr, resAddr];
  }

  async createUnexistentConsumers(tenantId) {
    const customersMap = this.selected.reduce((p, s) => {
      const [fn, ln, , resAddr] = this.getCastomerNameAndAddress(s);
      const sn = s['Scheduling Note'] || (p[s.Customer] && p[s.Customer].sn) || '';
      return { ...p, [s.Customer]: { name: s.Customer, consumer: s.consumer, ln, fn, resAddr, sn } };
    }, {});
    const customers: any[] = Object.values(customersMap);
    const consumers = await Promise.all(
      customers.map(({ consumer, ln, fn, resAddr, sn }: any) => {
        if (consumer) return consumer;
        this.dss
          .getApi<ConsumerApi>(Consumer)
          .sendEmailAboutPendingConsumer(`${fn} ${ln}`, resAddr, sn, moment().format('MM/DD/YYYY hh:mm A'))
          .toPromise();
        return this.dss
          .getApi<ConsumerApi>(Consumer)
          .myCreateWithRelated({
            status: 'PENDING',
            tenantId,
            person: { firstname: fn, lastname: ln, contact: { addresses: [resAddr] } },
          })
          .toPromise();
      }),
    );
    consumers.forEach((c: ConsumerAddressView, i) => (customersMap[customers[i].name].consumer = c));
    this.selected.forEach(s => (s.consumer = customersMap[s.Customer].consumer));
  }

  async loadConsumers(accepted) {
    const customersMap = accepted.reduce((p, s) => {
      const [fn, ln, adcAddr, resAddr] = this.getCastomerNameAndAddress(s);
      const adc = this.destinationsMap[adcAddr.split(',')[0]] || { short: adcAddr };
      return { ...p, [s.Customer]: { name: s.Customer, ln, fn, resAddr, adc } };
    }, {});
    const customers: any[] = Object.values(customersMap);
    const conss = await Promise.all(
      customers.map(({ ln, fn, resAddr: { street, zip } }: any) =>
        this.dss
          .getApi<ConsumerAddressViewApi>(ConsumerAddressView)
          .find<ConsumerAddressView>(
            {
              where: {
                person_lastname: { like: `%${ln}%` },
                person_firstname: { like: `%${fn}%` },
                contact_addresses_0_street: { like: `%${street.split(' ')[0]}%` }, // search by house number
                contact_addresses_0_zip: { like: `%${zip}%` }, // search by zip in zip string separated by || delimiter
                status: { inq: ['ACTIVE', 'PENDING'] },
              },
            },
            hAll,
          )
          .toPromise(),
      ),
    );
    const consumers: ConsumerAddressView[] = conss.map(([c]) => c);
    consumers.forEach((c: ConsumerAddressView, i) => (customersMap[customers[i].name].consumer = c));
    accepted.forEach(s => {
      s.consumer = customersMap[s.Customer].consumer;
      s.adc = customersMap[s.Customer].adc;
    });
  }

  pushDataToManifestsMap(manifestsMap) {
    this.selected.forEach(({ meta, dt, consumer, adc, leg, Customer }) => {
      const [o, d] = meta.isReturn ? [adc.short, 'RESIDENCE'] : ['RESIDENCE', adc.short];
      const [e, c, v, esc] = [meta.employeeId, consumer.id, meta.vehicleId, meta.esc];
      const [t, at, dot] = [meta.t, meta.at, meta.dot];
      const [tr, b, st, rt, rid] = [meta.tripSeq, 'MTM', 'AMB_TRIP', false, meta.tripId];
      manifestsMap[dt].data.push({ t, at, dot, tr, s: 0, rt, rid, o, d, b, st, e, c, v, esc, Customer });
    });
  }

  async addToManifest() {
    const tenantId = this.auth.getCurrentTenant();
    const manifestsMap = this.selected.reduce(
      (p, { dt }) => ({ ...p, [dt]: { requestID: new Guid().toString(), date: dt, data: [] } }),
      {},
    );
    await this.loadManfiests(manifestsMap);
    await this.createUnexistentConsumers(tenantId);
    this.pushDataToManifestsMap(manifestsMap);
    for (const { id, data } of Object.values<TripManifest>(manifestsMap)) {
      if (!id) continue;
      for (const { Customer, ...d } of data)
        try {
          const res: TripManifestRec = await this.helper.api
            .safeSaveRecordV2(id, d, headers => headers.append('x-caller', 'AutoDispatch'))
            .toPromise();
          // wait for the response a few seconds
          // await new Promise(resolve => setTimeout(resolve, 2000));
          const a = this.message.accepted.find(({ meta }) => meta.tripId === res.rid);
          if (a) a.meta.allowed = true;
        } catch (err) {
          this.showToast(`Error adding to Manifest (${Customer}): ${err.message}`, 'error');
        }
    }
    const manifests = await Promise.all(
      Object.values(manifestsMap).map(({ id, requestID, data, date }: any) =>
        id ? null : this.helper.api.create(new TripManifest({ requestID, date, data })).toPromise(),
      ),
    );

    manifests.forEach(
      m =>
        m &&
        m.data.forEach(d => {
          const a = this.message.accepted.find(({ meta }) => meta.tripId === d.rid);
          if (a) a.meta.allowed = true;
        }),
    );

    await this.updateTripsAllowed();
  }

  async markAsGranted() {
    this.selected.forEach(({ meta }) => (meta.allowed = true));
    await this.updateTripsAllowed();
  }

  async updateTripsAllowed() {
    this.message.tripsAllowed = this.message.accepted.reduce((p, { meta: { allowed } }) => p + +!!allowed, 0);
    await this.dss
      .getApi<AutoDispatchLogApi>(AutoDispatchLog)
      .updateAll({ id: this.message.id }, { tripsAllowed: this.message.tripsAllowed, accepted: this.message.accepted })
      .toPromise();
    this.grid.instance.refresh();
  }

  showToast(message: string, type: string = 'info') {
    this.toastMessage = message;
    this.toastType = type;
    this.isToastVisible = true;
  }
}
